export interface HeroSlide {
  id: string;
  title: string;
  type: "movie" | "tvshow";
  tagline: string;
  genres: string[];
  year: number;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "song-chronicle",
    title: "大宋风云录",
    type: "tvshow",
    tagline: "乱世之中，守城、守心、守约。一幅波澜壮阔的时代群像长卷。",
    genres: ["历史", "古装"],
    year: 2025,
    image: "https://readdy.ai/api/search-image?query=Cinematic%20epic%20wide%20key%20art%2C%20ancient%20Chinese%20fortress%20city%20on%20a%20mountain%20pass%20under%20a%20dramatic%20stormy%20sky%2C%20lone%20figures%20on%20the%20walls%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20cinematic%20mood%2C%20no%20typography&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
  {
    id: "interstellar-night",
    title: "星际迷航：暗夜边界",
    type: "movie",
    tagline: "穿越虫洞，抵达宇宙的暗夜边界，真相正缓缓睁开双眼。",
    genres: ["科幻", "冒险"],
    year: 2025,
    image: "https://readdy.ai/api/search-image?query=Cinematic%20epic%20wide%20key%20art%2C%20vast%20glowing%20wormhole%20in%20deep%20space%20with%20a%20small%20spaceship%20silhouette%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20cinematic%20mood%2C%20no%20typography&width=1600&height=900&seq=hero-02&orientation=landscape",
  },
  {
    id: "changan-night",
    title: "长安幻夜",
    type: "movie",
    tagline: "上元灯会之上，一座倒悬幻城浮现，横跨三百年的人妖之约就此揭幕。",
    genres: ["古装", "奇幻"],
    year: 2025,
    image: "https://readdy.ai/api/search-image?query=Cinematic%20epic%20wide%20key%20art%2C%20ancient%20Chinese%20lantern%20city%20at%20night%20with%20a%20floating%20inverted%20palace%20above%2C%20thousands%20of%20lights%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20cinematic%20mood%2C%20no%20typography&width=1600&height=900&seq=hero-03&orientation=landscape",
  },
  {
    id: "future-epoch",
    title: "未来纪元",
    type: "tvshow",
    tagline: "当意识可以上传，尊严与自由，成了最昂贵的奢侈品。",
    genres: ["科幻"],
    year: 2025,
    image: "https://readdy.ai/api/search-image?query=Cinematic%20epic%20wide%20key%20art%2C%20futuristic%20neon%20megacity%20with%20glowing%20data%20streams%20rising%20into%20the%20sky%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20cinematic%20mood%2C%20no%20typography&width=1600&height=900&seq=hero-04&orientation=landscape",
  },
  {
    id: "jianghu-lantern",
    title: "江湖夜雨十年灯",
    type: "tvshow",
    tagline: "十年之后，少年持旧剑重返江湖，只为讨一个公道。",
    genres: ["武侠", "古装"],
    year: 2025,
    image: "https://readdy.ai/api/search-image?query=Cinematic%20epic%20wide%20key%20art%2C%20swordsman%20standing%20in%20the%20rain%20before%20a%20glowing%20lantern%20in%20an%20ancient%20alley%20at%20night%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20cinematic%20mood%2C%20no%20typography&width=1600&height=900&seq=hero-05&orientation=landscape",
  },
];